import { createAsyncThunk } from '@reduxjs/toolkit';
import { Moment } from 'moment';
import * as M from '~/domain/model';
import * as HarvestingOrderServices from '~/services/producer/HarvestingOrder';
import { alertRequest } from '../../alert/actions';
import { getErrorResponseMessage } from '~/utils/getErrorResponseMessage';

export const fetchHarvestingOrdersByCustomer = createAsyncThunk(
  'harvestingOrders/fetchHarvestingOrdersByCustomer',
  async (
    params: M.HarvestingOrderFetchParams,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response =
        await HarvestingOrderServices.findHarvestingOrdersByCustomer(params);
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao carregar pedidos para colher.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchHarvestingOrdersByProduct = createAsyncThunk(
  'harvestingOrders/fetchHarvestingOrdersByProducts',
  async (
    params: M.HarvestingOrderFetchParams,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response =
        await HarvestingOrderServices.findHarvestingOrdersByProduct(params);
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao carregar pedidos para colher.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchKlokHarvestingOrdersByCustomer = createAsyncThunk(
  'harvestingOrders/fetchKlokHavestingOrdersByCustomer',
  async (
    params: M.HarvestingOrderFetchParams,
    { dispatch, rejectWithValue }
  ) => {
    const formattedParams = {
      Data: {
        SiteId: params.SiteId,
        DeliveryDate: params.DeliveryDate,
        Type: params.Type,
        ProductCategoryId: params.ProductCategoryId,
        ProductGroupId: params.ProductGroupId,
        CustomerId: params.CustomerId,
        ExpeditionId: params.ExpeditionId,
        ProductId: params.ProductId,
        ProductRecipient: params.ProductRecipient,
        QualityId: params.ProductQuality
      },
      PageSize: params.PageSize,
      PageNumber: params.PageNumber
    };
    try {
      const response =
        await HarvestingOrderServices.findKlokHarvestingOrdersByCustomer(
          formattedParams
        );
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao carregar pedidos para colher.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchKlokHarvestingOrdersByProduct = createAsyncThunk(
  'harvestingOrders/fetchKlokHavestingOrdersByProducts',
  async (
    params: M.HarvestingOrderFetchParams,
    { dispatch, rejectWithValue }
  ) => {
    const formattedParams = {
      Data: {
        SiteId: params.SiteId,
        DeliveryDate: params.DeliveryDate,
        Type: params.Type,
        ProductCategoryId: params.ProductCategoryId,
        ProductGroupId: params.ProductGroupId,
        CustomerId: params.CustomerId,
        ExpeditionId: params.ExpeditionId,
        ProductId: params.ProductId,
        ProductRecipient: params.ProductRecipient,
        QualityId: params.ProductQuality
      },
      PageSize: params.PageSize,
      PageNumber: params.PageNumber
    };
    try {
      const response =
        await HarvestingOrderServices.findKlokHarvestingOrdersByProduct(
          formattedParams
        );
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao carregar pedidos para colher.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const generatePrintList = createAsyncThunk(
  'harvestingOrders/generatePrintList',
  async (
    params: { siteId: number; interOrderIds: number[]; volOrderIds: number[] },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await HarvestingOrderServices.generateListToPrint(
        params
      );
      return response.data;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao carregar pedidos para colher.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateHarvestingOrders = createAsyncThunk(
  'harvestingOrders/updateHarvestingOrders',
  async (
    params: {
      itemId: number;
      origin: string;
      internalObservation: string;
    }[],
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response =
        await HarvestingOrderServices.updateHarvestingOrdersRequest(params);
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(err, 'Erro ao alterar pedido.');
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export type IOrdersToCollectParams = {
  Data: {
    siteId: number;
    deliveryDate: string | Moment;
    type: string;
  };
  pageSize: number;
  pageNumber: number;
};

export const fetchAllPrintData = createAsyncThunk(
  'harvestingOrders/fetchAllPrintData',
  async (params: IOrdersToCollectParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await HarvestingOrderServices.getAllPrintData(params);
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao carregar gerenciamento de impressão.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const DeletePrintByIds = createAsyncThunk(
  'harvestingOrders/DeletePrintByIds',
  async (ids: number[], { dispatch, rejectWithValue }) => {
    try {
      const response = await HarvestingOrderServices.DeletePrintListByIds(ids);
      dispatch(alertRequest('Excluído com sucesso!', 'success'));
      return response;
    } catch (err) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao deletar lista de impressão.'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);
